<div>
  <a mat-button [routerLink]="['/koine/vol5']">
    Latest issue
  </a>
</div>
<br>
<div class="toptext">
  <p>
    In ancient Greece, "Koine Greek" was a common dialect that became de facto the lingua franca across much of the
    Mediterranean and
    Near Eastern, facilitating trade and cultural exchange.
    <br>
    Much like our purpose, Koine Greek helped integrating vastly
    different societies. <br> Read our <a routerLink="/koine/open-access-statement">Open Access Statement</a>.
  </p>
</div>
<h1>About De Cifris Koine</h1>
<div class="text">
  <p>
    <img src="../../../../../assets/images/icons/flags/3x2/US.svg" alt="US Flag" style="width:24px; height:auto;">
    <img src="../../../../../assets/images/icons/flags/3x2/GB.svg" alt="GB Flag" style="width:24px; height:auto;">
    <b>English</b>
    <br><br>
    De Cifris Koine is a book series published by De Cifris Press, publishing house of the national association
    De Componendis Cifris, whose activities focus on cryptography and related topics. Volumes of De Cifris Koine
    form the voice of the Italian cryptographic community, since they collect notes from both scientific
    and educational events and summaries of papers of its members and their activities. In particular, De
    Cifris Koine hosts conference and workshop proceedings, including short abstracts.
    <br>
    Topics covered in volumes of De Cifris Koine relate to cryptography and its applications and connections
    with other disciplines, for example coding theory, branches of maths such as algebra, number theory and geometry,
    computer science with a focus on cyber security and theoretical computer science, electronic engineering,
    communications engineering, history and law of cryptography.
    <br>
    Accepted articles are either in Italian, English or French.
    <br>
    Volumes are published quarterly.
    <br>
    <b>We are 100% <a href="https://en.wikipedia.org/wiki/Diamond_open_access">Diamond Open
        Access</a>: nobody should pay to publish and nobody should pay to read.</b>
  </p>
</div>
<div class="text">
  <p>
    <img src="../../../../../assets/images/icons/flags/3x2/IT.svg" alt="Italian Flag" style="width:24px; height:auto;">
    <b>Italiano</b>
    <br><br>
    De Cifris Koine è una collana editoriale curata da De Cifris Press, marchio dell'associazione nazionale De
    Componendis Cifris dedicata allo studio e alla divulgazione della crittografia e delle discipline correlate.
    Questa collana rappresenta un punto di riferimento per la comunità crittografica italiana, offrendo una
    panoramica delle ricerche e delle innovazioni nel campo.
    Attraverso la pubblicazione degli atti di conferenze e workshop, De Cifris Koine fornisce non solo
    approfondimenti scientifici, ma anche contributi divulgativi, mettendo in luce i progressi e le attività dei
    principali esponenti in questo ambito.
    <br>
    La serie abbraccia un ampio spettro di argomenti, estendendosi oltre la crittografia stessa per includere le
    sue molteplici applicazioni e intersezioni con altre discipline. Tra queste, si annoverano la teoria dei
    codici, vari rami della matematica come l'algebra, la teoria dei numeri e la geometria, l'informatica con un
    focus particolare sulla cybersecurity e sull'informatica teorica, nonché l'ingegneria elettrica, le
    telecomunicazioni, la storia e gli aspetti legali legati alla crittografia.
    <br>
    Gli articoli pubblicati in questa collana sono accettati in tre lingue: italiano, inglese e francese.
    <br>
    I volumi sono pubblicati trimestralmente.
    <br>
    <b>Siamo 100% <a href="https://en.wikipedia.org/wiki/Diamond_open_access">Diamond Open Access</a>: nessuno dovrebbe
      pagare per
      pubblicare e nessuno dovrebbe pagare per leggere.</b>
  </p>
</div>
<div class="text">
  <p>
    <img src="../../../../../assets/images/icons/flags/3x2/FR.svg" alt="French Flag" style="width:24px; height:auto;">
    <b>Français</b>
    <br><br>
    La De Cifris Koine est une collection publiée par la De Cifris Press de l'association nationale italienne
    De Componendis Cifris. Elle est consacrée à l'étude et à la diffusion de la cryptographie et des disciplines
    connexes.
    Cette collection est une référence importante pour la communauté cryptographique italienne, offrant une vue
    d'ensemble de la recherche et des innovations dans ce domaine. Grâce à la publication d'actes de conférences
    et de groupes de travail (workshops), la De Cifris Koine fournit non seulement des contributions
    scientifiques académiques, mais aussi des contributions à destination du grand public, mettant en lumière
    les progrès et les activités des principaux acteurs et des principales actrices du domaine.
    <br>
    Les articles de cette collection couvrent un large éventail de sujets allant de la cryptographie à ses
    nombreuses applications et intersections avec d'autres disciplines. On y retrouve notamment la théorie des codes,
    diverses branches des mathématiques telles que l'algèbre, la théorie des nombres et la géométrie,
    l'informatique, avec un accent sur la sécurité informatique et l'informatique théorique, ainsi que le génie
    électrique, les télécommunications et les aspects juridiques de la cryptographie.
    <br>
    Les articles soumis à la De Cifris Koine sont acceptés en italien, anglais et français.
    <br>
    La fréquence de publication est trimestrielle.
    <br>
    <b>Nous sommes 100% <a href="https://en.wikipedia.org/wiki/Diamond_open_access">Diamond Open Access</a> : personne
      ne devrait payer pour
      publier et personne ne devrait payer pour lire.</b>
  </p>
</div>